(() => {
  const config = document.currentScript.dataset;
  const nameEmpty = el => !el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby') && !el.textContent.trim() && !Array.from(el.querySelectorAll('img')).some(img => img.alt.trim());
  const iconPaths = {
    'la-shopping-bag': 'M5 7h14l1 14H4L5 7Zm3 0V5a4 4 0 0 1 8 0v2',
    'la-clipboard': 'M9 4H5v17h14V4h-4M9 2h6v4H9V2Z',
    'la-clipboard-list': 'M9 4H5v17h14V4h-4M9 2h6v4H9V2ZM8 11h8M8 15h8',
    'la-arrow-right': 'M4 12h16m-6-6 6 6-6 6',
    home: 'm3 11 9-8 9 8M5 10v11h5v-7h4v7h5V10'
  };
  const duoVariants = JSON.parse(document.getElementById('tasha-duo-variants')?.textContent || '[]');
  let explicitDuoChoice = '';
  const duoMessage = () => config.combinationRequired;
  const showDuoError = () => {
    const picker = document.querySelector('.tasha-combination-select');
    const status = document.querySelector('.tasha-selected-combination');
    if (status) {
      status.textContent = duoMessage();
      status.style.color = '#8d2533';
      status.style.fontWeight = '600';
    }
    if (picker) {
      picker.setAttribute('aria-invalid', 'true');
      picker.focus();
      picker.scrollIntoView({block: 'center', behavior: 'smooth'});
    }
  };
  const duoReady = () => {
    const picker = document.querySelector('.tasha-combination-select');
    const colours = picker?.closest('#nt_select_ppr_0');
    const choice = picker && colours?.querySelectorAll('.swatch_pr_item')[Number(picker.value)];
    const variant = duoVariants.find(item => item.title === explicitDuoChoice);
    return Boolean(explicitDuoChoice && picker?.value !== '' && choice?.dataset.escape === explicitDuoChoice && variant?.available);
  };
  const guardDuoPurchase = event => {
    if (config.duo !== 'true') return;
    const target = event.target instanceof Element ? event.target : event.target.parentElement;
    const purchase = target?.closest('.sticky_atc_js, #cart-form_ppr .single_add_to_cart_button, #cart-form_ppr .shopify-payment-button, #cart-form_ppr shopify-accelerated-checkout, #cart-form_ppr [name="checkout"], #cart-form_ppr [name="buy_now"]');
    const submitted = event.type === 'submit' && target?.matches('#cart-form_ppr');
    if (!purchase && !submitted) return;
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    if (duoReady()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showDuoError();
  };
  if (config.duo === 'true') {
    document.addEventListener('click', guardDuoPurchase, true);
    document.addEventListener('submit', guardDuoPurchase, true);
    document.addEventListener('keydown', guardDuoPurchase, true);
  }
  const syncDuo = (colours, choice, updateButton = false) => {
    const form = colours.closest('form');
    const variant = duoVariants.find(item => item.title === choice.dataset.escape);
    if (!form || !variant) return;
    colours.dataset.tashaChoice = choice.dataset.escape;
    colours.querySelectorAll('.swatch_pr_item').forEach(item => item.classList.toggle('is-selected', item === choice));
    const current = colours.querySelector('.nt_name_current');
    if (current && current.textContent !== choice.dataset.tashaLabel) current.textContent = choice.dataset.tashaLabel;
    const status = document.querySelector('.tasha-selected-combination');
    const statusText = config.selectedCombination.replace('[colour]', choice.dataset.tashaLabel);
    if (status && status.textContent !== statusText) status.textContent = statusText;
    const original = form.querySelector('select[name="id"]');
    if (original && original.value !== String(variant.id)) {
      original.value = String(variant.id);
      original.dispatchEvent(new Event('change', {bubbles:true}));
    }
    document.querySelectorAll('.js_sticky_sl').forEach(select => { select.value = String(variant.id); });
    document.querySelectorAll('.sticky_atc_a').forEach(label => { label.textContent = choice.dataset.tashaLabel; });
    if (updateButton) document.querySelectorAll('.sticky_atc_js').forEach(button => { button.disabled = !variant.available; button.classList.toggle('disabled', !variant.available); });
    const button = form.querySelector('.single_add_to_cart_button');
    if (button && updateButton && !button.classList.contains('loading')) { button.classList.toggle('disabled', !variant.available); button.disabled = !variant.available; }
  };
  const update = () => {
    document.querySelectorAll('i.la, i.las, i.lar, i.lab').forEach(icon => {
      const key = Object.keys(iconPaths).find(name => icon.classList.contains(name)) || (Array.from(icon.classList).some(name => name.startsWith('la-https:')) ? 'home' : null);
      if (!key) return;
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      const size = key === 'la-shopping-bag' && icon.closest('.empty') ? 64 : 20;
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', size);
      svg.setAttribute('height', size);
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.7');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('class', 'tasha-svg-icon ' + Array.from(icon.classList).filter(name => !['la', 'las', 'lar', 'lab'].includes(name)).join(' '));
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', iconPaths[key]);
      svg.append(path);
      icon.replaceWith(svg);
    });
    document.querySelectorAll('.nt_action .tcount').forEach(el => { if (el.getAttribute('aria-hidden') !== 'true') el.setAttribute('aria-hidden', 'true'); });
    document.querySelectorAll('.jdgm-carousel-item__product-image').forEach(el => {
      if (!el.hasAttribute('width')) el.setAttribute('width', '56');
      if (!el.hasAttribute('height')) el.setAttribute('height', '56');
    });
    if (document.querySelector('.la, .las, .lar, .lab') && !document.getElementById('tasha-line-awesome')) {
      const css = document.createElement('link');
      css.id = 'tasha-line-awesome';
      css.rel = 'stylesheet';
      css.href = config.lineAwesome;
      document.head.append(css);
    }
    document.querySelectorAll('.cat_view_page').forEach(el => {
      const col = el.dataset.col;
      const count = col === '15' ? 5 : 12 / Number(col);
      el.setAttribute('aria-label', el.dataset.mode === 'list' ? config.list : config.grid.replace('[count]', count));
    });
    document.querySelectorAll('.btn_zoom, .zoom_img, .js_zoom_img, .show_btn_pr_gallery').forEach(el => { el.setAttribute('aria-label', el.querySelector('.tt_txt')?.textContent.trim() || config.zoom); });
    document.querySelectorAll('.swatch_pr_item').forEach(el => {
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      const label = (el.dataset.escape || el.textContent.trim()).replace('Peach+Back', 'Peach+Black').replace(/[+\-]/g, ' + ');
      el.dataset.tashaLabel = label;
      el.setAttribute('aria-label', label);
      el.setAttribute('aria-pressed', String(el.classList.contains('is-selected')));
    });
    const colours = document.querySelector('.template-product #nt_select_ppr_0');
    if (colours && config.duo === 'true') {
      if (location.pathname.includes('/products/tashas-duo-bag-offer') && !document.querySelector('.tasha-colour-hint')) {
        const hint = document.createElement('p');
        hint.className = 'tasha-colour-hint';
        hint.textContent = config.colourOrder;
        colours.before(hint);
      }
      let picker = colours.querySelector('.tasha-combination-select');
      const choices = Array.from(colours.querySelectorAll('.swatch_pr_item'));
      if (!picker && choices.length > 1) {
        picker = document.createElement('select');
        picker.className = 'tasha-combination-select';
        picker.setAttribute('aria-label', config.chooseCombination);
        picker.required = true;
        picker.setAttribute('aria-describedby', 'tasha-combination-status');
        const empty = document.createElement('option');
        empty.value = '';
        empty.disabled = true;
        empty.textContent = config.chooseCombination;
        picker.append(empty);
        choices.forEach((choice, index) => {
          const option = document.createElement('option');
          option.value = String(index);
          option.textContent = choice.dataset.tashaLabel;
          picker.append(option);
        });
        picker.addEventListener('change', () => {
          if (picker.value !== '') {
            const choice = choices[Number(picker.value)];
            explicitDuoChoice = choice.dataset.escape;
            picker.removeAttribute('aria-invalid');
            choice.click();
            syncDuo(colours, choice, true);
          }
          requestAnimationFrame(update);
        });
        colours.querySelector('ul').before(picker);
        colours.classList.add('tasha-has-combination-select');
      }
      const preferred = choices.find(choice => choice.dataset.escape === colours.dataset.tashaChoice);
      if (preferred) syncDuo(colours, preferred);
      const selected = explicitDuoChoice ? choices.find(choice => choice.dataset.escape === explicitDuoChoice) : null;
      if (!explicitDuoChoice) document.querySelectorAll('#cart-form_ppr .single_add_to_cart_button,.sticky_atc_js').forEach(button => { button.disabled = false; button.classList.remove('disabled'); });
      if (picker) {
        choices.forEach((choice, index) => {
          const variant = duoVariants.find(item => item.title === choice.dataset.escape);
          picker.options[index + 1].disabled = variant?.available === false || choice.classList.contains('is--soldout') || choice.classList.contains('is-soldout') || choice.getAttribute('aria-disabled') === 'true';
        });
        picker.value = selected ? String(choices.indexOf(selected)) : '';
      }
      let status = document.querySelector('.tasha-selected-combination');
      if (!status) {
        status = document.createElement('p');
        status.className = 'tasha-selected-combination';
        status.id = 'tasha-combination-status';
        status.setAttribute('aria-live', 'polite');
        status.setAttribute('aria-atomic', 'true');
        colours.after(status);
      }
      const statusText = selected ? config.selectedCombination.replace('[colour]', selected.dataset.tashaLabel) : (picker?.getAttribute('aria-invalid') === 'true' ? duoMessage() : '');
      if (selected) { status.style.color = ''; status.style.fontWeight = ''; }
      if (status.textContent !== statusText) status.textContent = statusText;
    }
    document.querySelectorAll('a[href*="/cart/change?quantity=0"]').forEach(el => el.setAttribute('aria-label', config.remove));
    document.querySelectorAll('.cart_item a.js_edit, .mini_cart_item a.js_edit').forEach(el => el.setAttribute('aria-label', config.edit));
    document.querySelectorAll('.search_header__submit').forEach(el => el.setAttribute('aria-label', config.search));
    document.querySelectorAll('.product a.db, .wishlistadd').forEach(el => {
      if (!el.classList.contains('wishlistadd') && !nameEmpty(el)) return;
      const product = el.closest('.product, .summary, .tasha-featured-summary');
      const title = product?.querySelector('.product-title, .product-info h3, .tasha-featured-title, h1')?.textContent.trim();
      if (el.classList.contains('wishlistadd')) el.setAttribute('aria-label', title ? `${config.wishlist}: ${title}` : config.wishlist);
      else if (title) el.setAttribute('aria-label', title);
    });
    document.querySelectorAll('.rating_sp_kl').forEach(el => {
      el.setAttribute('aria-label', config.reviews);
      if (!el.querySelector('.tasha-review-link-label')) {
        const label = document.createElement('span');
        label.className = 'tasha-review-link-label';
        label.textContent = config.reviews;
        el.append(label);
      }
    });
    document.querySelectorAll('#nt_backtop').forEach(el => el.setAttribute('aria-label', config.top));
    document.querySelectorAll('a.pa.z_100[href="/collections/duo-bag-deals"]').forEach(el => { if (nameEmpty(el)) el.setAttribute('aria-label', config.deals); });
    document.querySelectorAll('.flickity-slider > *').forEach(el => { el.inert = el.getAttribute('aria-hidden') === 'true'; });
  };
  document.addEventListener('keydown', event => {
    const swatch = event.target.closest('.swatch_pr_item');
    if (swatch && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      swatch.click();
    }
  });
  document.addEventListener('click', event => {
    if (event.target.closest('.swatch_pr_item')) requestAnimationFrame(update);
  });
  document.addEventListener('change', event => { if (event.target.closest('.cart-form, [id^=cart-form], .tasha-combination-select')) requestAnimationFrame(update); });
  document.addEventListener('load', event => {
    if (event.target.tagName === 'SCRIPT' && /(?:swatch|produc)\.min\.js/.test(event.target.src)) {
      requestAnimationFrame(() => {
        const colours = document.querySelector('#nt_select_ppr_0');
        const choice = colours && Array.from(colours.querySelectorAll('.swatch_pr_item')).find(item => item.dataset.escape === colours.dataset.tashaChoice);
        if (choice) { choice.click(); syncDuo(colours, choice, true); update(); }
      });
    }
  }, true);
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(); });
  });
  update();
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
})();


